import $ from 'jquery';
export default class MainMenu {
    static mount() {
        $(function () {
            new MainMenu();
        });
    }
    constructor() {
        this.$elements = $('nav.menu-main');
        this.$elements.each((index, element) => {
            $(element).data('MainMenu', this);
        });
        this.registerEvents();
        this.initMenuStateFromCurrentPage();
    }
    registerEvents() {
        const $subMenuItems = this.$elements.find('.wp-block-navigation-item.has-child > a,.wp-block-navigation-item.has-child > button');
        $subMenuItems.on('click', (event) => this.onSubmenuToggleClick(event));
        this.registerSearchEvents();
    }
    registerSearchEvents() {
        const $searchButton = this.$elements.find('.wp-block-search__button');
        const $searchForm = this.$elements.find('form.wp-block-search');
        const $searchInput = this.$elements.find('.wp-block-search__input');
        $searchButton.on('click', (event) => {
            $searchForm.toggleClass('is-visible');
            $searchInput.trigger('focus');
            return true;
        });
    }
    initMenuStateFromCurrentPage() {
        const $currentMenuItem = this.$elements.find('.current-menu-item.has-child');
        if ($currentMenuItem.length) {
            $currentMenuItem.addClass('submenu-is-open');
        }
        const $currentMenuParent = this.$elements.find('a.current-menu-ancestor').closest('.has-child');
        if ($currentMenuParent.length) {
            $currentMenuParent.addClass('submenu-is-open');
        }
        const currentPath = window.location.href;
        const $navItems = this.$elements.find('.wp-block-navigation-item');
        var currentPathNoHash = currentPath.replace(/#.*$/, '');
        $navItems.each((index, element) => {
            var _a;
            const $item = $(element);
            const $link = $item.find('a');
            const href = ((_a = $link.attr('href')) !== null && _a !== void 0 ? _a : '').replace(/#.*$/, '');
            if (currentPath === href) {
                $item.addClass('current-menu-item');
            }
        });
    }
    onSubmenuToggleClick(event) {
        const $menuItem = $(event.currentTarget).parent();
        const $target = $(event.target).parent();
        const $subMenuContainer = $menuItem.find('.wp-block-navigation__submenu-container');
        if ($subMenuContainer.length && $.contains($subMenuContainer[0], $target[0])) {
            return true;
        }
        const breakpointXl = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-xl');
        if (window.matchMedia(`(min-width: ${breakpointXl})`).matches) {
            return true;
        }
        if ($menuItem.hasClass('submenu-is-open')) {
            $menuItem.removeClass('submenu-is-open');
        }
        else {
            const $currentMainMenu = $menuItem.closest('nav.menu-main');
            $currentMainMenu.find('.submenu-is-open').removeClass('submenu-is-open');
            $menuItem.addClass('submenu-is-open');
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        return true;
    }
}
